module.exports = __webpack_public_path__ + "img/學習資源.e0307534.png";